import { Dialog, DialogContent, DialogTitle } from '@efexteam/components';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { UploadFileExampleProps } from '../FileInput/FileInput.type';

interface FileInputExampleModalProps {
  data: UploadFileExampleProps | null;
  open: boolean;
  onClose: () => void;
}

const FileInputExampleModal = ({
  data,
  open,
  onClose,
}: FileInputExampleModalProps) => {
  const { t } = useTranslation();

  if (!data) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle showCloseButton onClick={onClose} />
      <DialogContent>
        {data.modalTitle && (
          <Typography variant="h6" sx={{ mb: 2 }}>
            {t(data.modalTitle)}
          </Typography>
        )}
        <img
          src={data.modalContent.image}
          alt="Example"
          style={{ width: '100%', height: 'auto' }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default FileInputExampleModal;
